export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'edtSkodahlaspa';

export const NAME = 'Skodahlaspa';
export const POLOZKY_HLASENI_O_SKODE = 'PolozkyHlaseniOSkode';

export const STAV_PLATBY_NEZAPLACENO = 1;
